<div [hidden]="!menuEnabled">
  <div class="row sr-only" id="divStart">
    <div class="col-10" style="height: Calc(100vh - 250px);">
      <div class="d-flex justify-content-around">
        <div class="start-btn item-center" (click)="StartProcess()">
          <div class="text-center" style="width: 100%;">
            <img class="mt-4" id="imgBtn">
          </div>
          <div class="btn-label">
            <div class="vertical-center centered-content" style="width: 100%;">
              <label style="font-size: 1.1rem;" id="BtnLabel" translate>Verifiaction identity at agent bank</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mb-3 text-center">
      <button class="btn btn-default" (click)="BackToHome()" translate>Home</button>
    </div>
  </div>

  <div class="row sr-only pt-3" id="divStart2">
    <div class="col-3" style="height: calc(100vh - 500px);"></div>
    <div class="col-5" >
      <div class="d-flex justify-content-around">
        <div id="btnDOPAParent">
          <div class="start-btn item-center" (click)="CreateTable1()" id="btnDOPA">

            <div class="text-center" style="width: 100%;">
              <img class="mt-4" src="../../assets/images/72ppi/72ppi/Web Portal-วิกฤต-ตัด-04_no_bg.png" id="imgBtn1">
            </div>
            <div class="btn-label">
              <div class="vertical-center centered-content" style="width: 100%;">
                <label style="font-size: 1.1rem;" translate>Verifiaction identity ndid</label>
              </div>
            </div>
            
          </div>
        </div>
        <div class="sr-only" id="btnByAgentBankParent">
          <div class="start-btn item-center" (click)="StartProcess()" id="btnByAgentBank">
            <div class="text-center" style="width: 100%;">
              <img class="mt-4" src="../../assets/images/receive_deposit_1.png" id="imgBtn2">
            </div>
            <div class="btn-label">
              <div class="vertical-center centered-content" style="width: 100%;">
                <label style="font-size: 1.1rem;" translate>Verifiaction identity at agent bank</label>
              </div>
            </div>
          </div>
        </div>

        <!-- <div id="btnNDIDParent">
          <div class="start-btn item-center md-1" (click)="OpenNDID()" id="btnNDID">
            <div class="text-center" style="width: 100%;">
              <img class="mt-4" src="../../assets/images/72ppi/72ppi/Web Portal-วิกฤต-ตัด-04_no_bg.png" id="imgBtn3">
            </div>
            <div class="btn-label">
              <div class="vertical-center centered-content" style="width: 100%;">
                <label style="font-size: 1.1rem;" translate>Verifiaction identity ndid</label>
              </div>
            </div>
          </div>
        </div> -->

      </div>
    </div>
    <div class="col-4" style="height: calc(100vh - 500px);"></div>
    <div class="col-12 mb-3 text-center">
      <button class="btn btn-default" (click)="BackToHome()" translate>Home</button>
    </div>
  </div>

  <!-- DOPA -->
  <div class="mt-3 mb-3 sr-only" id="divDOPA">
    <div class="row">
      <div class="col-12 col-sm-8 col-md-6 container">
        <div class="row mt-4 mb-4">
          <div class="col-12 text-center">
            <h4 class="text-cust-blue" translate>Verify Verifiaction identity by DOPA</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 required" translate>
            Name
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" id="FirstNameDOPA">
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4 required" translate>
            Surname
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" id="LastNameDOPA">
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4 required" translate>
            ID no.
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" id="IDNoDOPA">
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4 required" translate>
            Laser Code
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" maxlength="13" id="LaserNoDOPA"
              (keypress)="numberAndAlphabetOnly($event)">
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4 required" translate>
            Date of Birth
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" id="BirthDateDOPA"
              placeholder="{{'dopaDobPlaceholder' | translate}}">
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4" translate>
            MobileNo
          </div>
          <div class="col-md-8">
            <input type="text" class="form-control" id="PhoneNoDOPA">
          </div>
        </div>
        <div class="row mt-4 mb-4">
          <div class="col-12 centered-content">
            <button class="btn btn-default m-2" (click)="StartProcess(true)" translate>Send</button>
            <button class="btn btn-default m-2" (click)="ClearText()" translate>Clear text</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End DOPA -->

  <!-- Details -->
  <div class="mt-3 mb-3 sr-only" id="divDetails">
    <div class="row">
      <div class="col-12 container">
        <div class="row">
          <div class="col-12 text-center">
            <div style="background-color: #006ED0; width:
                  fit-content; border-radius: 50px; padding:
                  20px;" class="mx-auto m-3">
              <img src="../../assets/images/home-icon.png" class="mx-auto" width="40">
            </div>
          </div>
        </div>

        <div class="row centered-content m-2">
          <div class="col-sm-3 col-md-2">
            <label translate>Ticket ID</label>
          </div>
          <div class="col-sm-4 col-md-4">
            <input id="TicketNo" type="text" class="form-control" readonly>
          </div>
        </div>
        <div class="row centered-content m-2">
          <div class="col-sm-3 col-md-2">
            <label id="CustomerType" translate>Company Type</label>
          </div>
          <div class="col-sm-4 col-md-4">
            <input id="CompanyType" type="text" class="form-control" readonly>
          </div>
        </div>
        <div class="row centered-content m-2" id="divCompanyName">
          <div class="col-sm-3 col-md-2">
            <label translate>CompanyName</label>
          </div>
          <div class="col-sm-4 col-md-4">
            <input id="CompanyName" type="text" class="form-control" readonly>
          </div>
        </div>
        <div class="row centered-content m-2" style="margin-top: 0px !important;" id="divTaxID">
          <div class="col-sm-3 col-md-2">
            <label translate>Regis Tax no.</label>
          </div>
          <div class="col-sm-4 col-md-4">
            <input id="RegistrationID" type="text" class="form-control" readonly>
          </div>
        </div>
        <div class="row centered-content m-2">
          <div class="col-sm-3 col-md-2">
            <label id="lblFirstName" translate>Attorney-in-fact's name</label>
          </div>
          <div class="col-sm-4 col-md-4">
            <input id="FirstName" type="text" class="form-control" readonly>
          </div>
        </div>
        <div class="row centered-content m-2">
          <div class="col-sm-3 col-md-2">
            <label id="lblLastName" translate>Attorney-in-fact's surname</label>
          </div>
          <div class="col-sm-4 col-md-4">
            <input id="LastName" type="text" class="form-control" readonly>
          </div>
        </div>
        <div class="row centered-content m-2">
          <div class="col-sm-3 col-md-2">
            <label translate>ID no.</label>
          </div>
          <div class="col-sm-4 col-md-4">
            <input id="CitizenID" type="text" class="form-control" readonly>
          </div>
        </div>

        <!-- Document List -->
        <div class="row centered-content">
          <div class="col-11 col-md-6" id="divDocList" disabled>
          </div>
        </div> 
        <!-- End Document List -->

        <div class="row sr-only centered-content" id="divUpload">
          <div class="col-md-6 m-4">
            <div class="upload-btn-wrapper" style="width: 120px; cursor: pointer;">
              <!-- <input type="text" id="txtFileName" class="form-control" placeholder="เลือกไฟล์..."> -->
              <button class="btn btn-default"><i class="fas fa-plus"></i>&nbsp;Upload</button>
              <input type="file" id="fileAttach" [accept]="AcceptExtension"
                (change)="FileSelect($event.target.files)" />
            </div>
            <div>
            <label id="onlydata"></label>
            </div>
            <!-- <button class="btn btn-default" (click)="UploadFile()"><i class="fas fa-upload"></i>&nbsp;Upload</button> -->
          </div>
        </div>

        <div class="row centered-content" id="divFiles">
          <div class="col-md-6">
            <table id="TableDocs" style="width: 100%;" class="table table-bordered table-hover
                  table-responsive-sm result-table display
                  nowrap">
              <thead class="sr-only">
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
            </table>
          </div>
        </div>

        <div class="row centered-content">
          <div class="col-sm-3 col-md-2 m-2">
            <label translate>StatusDoc</label>
          </div>
          <div class="col-sm-4 col-md-4 m-2">
            <input id="Status" type="text" class="form-control" readonly>
          </div>
        </div>

        <div class="row centered-content">
          <div class="col-sm-3 col-md-2 m-2">
            <label translate>Remark</label>
          </div>
          <div class="col-sm-4 col-md-4 m-2">
            <input id="Remark" type="text" class="form-control" readonly>
          </div>
        </div>

        <div class="row" id="divButtons">
          <div class="col-12 centered-content">
            <button type="button" class="btn btn-default m-4 sr-only" id="btnSendData" (click)="SendData()"
              translate>Send</button>
            <button type="button" class="btn btn-default m-4" (click)="BackToHome()" translate>Home</button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- End Details -->

  <!-- OTP -->
  <div class="mt-5 mb-3 sr-only" id="divOTP">
    <div class="row centered-content">
      <div class="col-12 col-sm-10 col-md-6">
        <div class="container">
          <div class="row mt-4 mb-4">
            <div class="col-12 text-center">
              <h4 class="text-cust-blue" translate>SMS-OTP</h4>
            </div>
          </div>
          <div class="row mt-4 mb-4">
            <div class="col-12 text-center">
              <p translate>The SMS-OTP will sent to your registered mobile number.</p>
              <p>
                <label id="PhoneNo" style="color: red; font-size: 1.5rem;">"0860451234"</label>
              </p>
              <p class="sr-only">กรุณาตรวจสอบ</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 centered-content" style="display:flex; vertical-align: bottom;">
              <label style="font-size: 1.1rem;">Reference Code: &nbsp;</label>
              <label style="color: red; font-size: 1.5rem;" id="OTPRefCode"></label>
            </div>
          </div>
          <div class="row m-2">
            <div class="col-12 centered-content">
              <label style="font-size: 1.25rem;" translate>Please input your SMS-OTP password.</label>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-sm-6 centered-content mt-1">
              <button type="button" class="btn btn-default w-100" id="btnRequestOTP" (click)="RequestOTP()"
                translate>RequestOTP</button>
            </div>
          </div>
          <div class="row mt-2 justify-content-center">
            <div class="col-6">
              <input type="password" id="OTP" class="form-control" placeholder="{{'SMS-OTP' | translate}}"
                style="font-size: 1.1rem; text-align: center;">
            </div>
          </div>
          <div class="row mt-4 mb-4 justify-content-center">
            <div class="col-sm-2 centered-content mt-1">
              <button type="button" class="btn btn-default w-100" id="btnSubmitOTP" (click)="SubmitOTP()"
                translate>SendOTP</button>
            </div>
            <div class="col-sm-2 centered-content mt-1">
              <button type="button" class="btn btn-default w-100" (click)="BackToHome()" translate>CancelOTP</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End OTP -->

  <!-- Condition -->
  <div class="mt-5 mb-3 sr-only" id="divCondition">
    <div class="row centered-content">
      <div class="col-12 col-sm-10 col-md-8">
        <div class="container">
          <div class="row mt-4 mb-4">
            <div class="col-12 text-center">
              <h4 class="text-cust-blue">นโยบายความเป็นส่วนตัว (Privacy Policy)</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-12"  id="refPolicy">
                <!--  <p><span style="font-size:16px">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;สถาบันคุ้มครองเงินฝาก (สคฝ.) เป็นหน่วยงานของรัฐ จัดตั้งขึ้นตามพระราชบัญญัติสถาบันคุ้มครองเงินฝาก พ.ศ.2551 ยึดมั่นการดำเนินงานตามหลักบรรษัทภิบาลในการปฏิบัติงานอย่างเคร่งครัด สคฝ. ขอขอบคุณสำหรับความไว้วางใจจากท่าน และตระหนักดีว่าท่านต้องการความปลอดภัยในการทำธุรกรรม และการรักษาข้อมูลส่วนบุคคล</span></p>
  
  <p><span style="font-size:16px">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;สคฝ. จึงได้กำหนดนโยบายความเป็นส่วนตัว (Privacy Policy) เพื่อให้ท่านมั่นใจเรื่องการคุ้มครองข้อมูลส่วนบุคคล การเก็บรักษาข้อมูลไว้เป็นความลับ รวมทั้งการเปิดเผยหรือการนำไปใช้ที่ต้องเป็นไปด้วยความรอบคอบ และคำนึงถึงความปลอดภัยของข้อมูลเป็นสำคัญ โดยท่านสามารถศึกษารายละเอียดของนโยบายความเป็นส่วนตัว (Privacy Policy) ได้ (เป็น share link file)</span></p>
  
  <p>&nbsp;</p>
  
  <p><span style="font-size:16px">ขอแสดงความนับถือ</span></p>
  
  <p><span style="font-size:16px">สถาบันคุ้มครองเงินฝาก</span></p>-->

              <!--<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                สถาบันคุ้มครองเงินฝาก (สคฝ.) เป็นหน่วยงานของรัฐ จัดตั้งขึ้นตามพระราชบัญญัติสถาบันคุ้มครองเงินฝาก
                พ.ศ.2551
                ยึดมั่นการดำเนินงานตามหลักบรรษัทภิบาลในการปฏิบัติงานอย่างเคร่งครัด สคฝ.
                ขอขอบคุณสำหรับความไว้วางใจจากท่าน
                และตระหนักดีว่าท่านต้องการความปลอดภัยในการทำธุรกรรม และการรักษาข้อมูลส่วนบุคคล
              </p>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                สคฝ. จึงได้กำหนดนโยบายความเป็นส่วนตัว (Privacy Policy)
                เพื่อให้ท่านมั่นใจเรื่องการคุ้มครองข้อมูลส่วนบุคคล
                การเก็บรักษาข้อมูลไว้เป็นความลับ รวมทั้งการเปิดเผยหรือการนำไปใช้ที่ต้องเป็นไปด้วยความรอบคอบ
                และคำนึงถึงความปลอดภัยของข้อมูลเป็นสำคัญ โดยท่านสามารถศึกษารายละเอียดของนโยบายความเป็นส่วนตัว (Privacy
                Policy) ได้
                (เป็น share link file)
              </p>
              <br />
              <p>
                ขอแสดงความนับถือ
                <br />
                สถาบันคุ้มครองเงินฝาก
              </p>-->
            </div>
          </div>
          <div class="row centered-content">
            <div class="col-12 col-md-11">
              <label class="checktable">
                <input type="checkbox" id="Accepted"><span class="checkmark"></span>
                <label translate>ยอมรับนโยบายความเป็นส่วนตัว</label>
              </label>
              <label class="checktable" style="display: none;">
                <input type="checkbox" id="ReceiveNews"><span class="checkmark" ></span>
                <label translate>ต้องการรับโฆษณาและข่าวสารประชาสัมพันธ์จากสถาบันคุ้มครองเงินฝาก</label>
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 centered-content">
            <button class="btn btn-default m-2" id="Accept" translate>ยอมรับ</button>
            <button class="btn btn-default m-2" id="Reject" translate>ปฏิเสธ</button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 centered-content">
            <button class="btn btn-default m-2" (click)="BackToHome()" translate>กลับสู่หน้าหลัก</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Condition -->

  <!-- ฺBank List -->
  <div class="mt-5 mb-3 sr-only" id="divBankList">
    <div class="row centered-content">
      <div class="col-12 col-sm-8 col-md-6 pb-4 container">
        <div class="row">
          <div class="col-12 text-center">
            <div style="background-color: #006ED0; width: fit-content; border-radius: 50px; padding: 20px;"
              class="mx-auto m-3">
              <img src="../../assets/images/home-icon.png" class="mx-auto" width="40">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <div id="divBankCard">
              <div class="row mt-3">
                <div class="col-12 centered-content">
                  <button class="btn bank-card">
                    <i class="fas fa-chevron-right bank-card-arrow"></i>
                    <img class="bank-card-icon" src="../../assets/images/bank.png">
                    <div class="text-left bank-card-title">
                      <span>ธนาคารกสิกรไทย</span>
                    </div>
                    <div class="text-left bank-card-info1">
                      <span>
                        <img src="../../assets/images/warning.png">
                        Effective: 01/01/63
                      </span>
                    </div>
                    <div class="text-left bank-card-info2">
                      <span translate>Phone no.</span><span>: 02-111-1111, 02-333-4444</span>
                    </div>
                  </button>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 centered-content">
                  <button class="btn bank-card">
                    <i class="fas fa-chevron-right bank-card-arrow"></i>
                    <img class="bank-card-icon" src="../../assets/images/bank.png">
                    <div class="text-left bank-card-title">
                      <span>ธนาคารกกรุงเทพ</span>
                    </div>
                    <div class="text-left bank-card-info1">
                      <span>
                        <img src="../../assets/images/warning.png">
                        Effective: 01/01/63
                      </span>
                    </div>
                    <div class="text-left bank-card-info2">
                      <span translate>Phone no.</span><span> 02-111-1111, 02-333-4444</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Bank List -->

  <!-- Refund Details -->
  <div class="mt-4 mb-3 sr-only" id="divSummary">
    <div class="row centered-content">
      <div class="col-12 col-md-11 container">
        <div class="row mt-4 mb-4">
          <div class="col-12 text-center">
            <h4 class="text-cust-blue" translate>Summary</h4>
          </div>
        </div>
        <div class="row centered-content">
          <div class="col-11">
            <fieldset>
              <legend translate>Account</legend>
              <table id="Table2" style="width:100%">
                <thead>
                  <tr>
                    <th style="width: 50%; border-top-left-radius: 1rem;" translate>RefundItem</th>
                    <th style="width: 25%; border-left: solid 2px white;" translate="">Amount</th>
                    <th style="width: 25%; border-left: solid 2px white; border-top-right-radius: 1rem;" translate>Unit
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="padding-left: 20px;" translate>Deposit Account</td>
                    <td style="text-align: right; padding-right: 30px;"><label id="NoOfAcc">2</label></td>
                    <td style="text-align: center;" translate>Account</td>
                  </tr>
                  <tr>
                    <td style="padding-left: 20px;" translate>Reimbursement Amount From Financial Institution</td>
                    <td style="text-align: right; padding-right: 30px;"><label id="Amount">901,000</label></td>
                    <td style="text-align: center;" translate>baht</td>
                  </tr>
                  <tr>
                    <td style="padding-left: 20px;" translate>Withholding Tax on Interest</td>
                    <td style="text-align: right; padding-right: 30px;"><label id="TaxAmount">1,000</label></td>
                    <td style="text-align: center;" translate>baht</td>
                  </tr>
                  <tr>
                    <td style="padding-left: 20px;" translate>Net Reimbursement Amount</td>
                    <td style="text-align: right; padding-right: 30px;"><label id="NetAmount">900,000</label></td>
                    <td style="text-align: center;" translate>baht</td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
        </div>
        <div class="row centered-content mt-2">
          <div class="col-11 centered-content">
            <button class="btn btn-default m-2" style="width: 200px;" id="btnAdditionalDoc" [ngModel]="PathPdf"
              ngDefaultControl (click)="openPDF(PathPdf)" translate><i
                class="fas fa-chevron-right bank-card-arrow"></i>ข้อมูลการขอเอกสารเพิ่ม</button>
            <button class="btn btn-default m-2" style="width: 150x;"  id="btnsentmaildoc" (click)="sentmailDoc()" translate><i
                class="fas fa-chevron-right bank-card-arrow"></i>ขอเอกสารผ่านทาง Email</button>
            <button class="btn btn-default m-2 sr-only" style="width: 180px;" id="btnInvestigate"
              (click)="InvestigateAndAppealStatus()">
              <i class="fas fa-chevron-right bank-card-arrow"></i>
              <label id="lblInvestigate">อุทธรณ์</label>
            </button>
          </div>
        </div>
        <div class="row centered-content mt-2" id="divPaymentStatus">
          <div class="col-11">
            <fieldset>
              <legend translate>Payment status</legend>
              <div id ="PaymentStatus1" style="padding-bottom: 15px;">
                <label id="PaymentStatus1_1" style="font-size: 1.1rem;">จ่ายคืนผู้ฝาก ธนาคาร A เลขที่เช็ค 1111111111
                  วันที่ออก 17/07/2563
                  เช็คเรียกเก็บแล้ว</label>
                <br />
                <label id="PaymentStatus2_1" style="font-size: 1.1rem;">วันที่โอน 17/07/2563</label>
                <br />
              </div>

              <div id ="PaymentStatus2" style="padding-bottom: 15px;">
                <label id="PaymentStatus1_2" style="font-size: 1.1rem;"></label>
                <br />
                <label id="PaymentStatus2_2" style="font-size: 1.1rem;"></label>
                <br />
              </div>

              <div id ="PaymentStatus3" style="padding-bottom: 15px;">
                <label id="PaymentStatus1_3" style="font-size: 1.1rem;"></label>
                <br />
                <label id="PaymentStatus2_3" style="font-size: 1.1rem;"></label>
                <br />
              </div>

              <div  id ="PaymentStatus4">
                <label id="PaymentStatus1_4" style="font-size: 1.1rem;">จ่ายคืนผู้ฝาก ธนาคาร A เลขที่เช็ค 1111111111
                  วันที่ออก 17/07/2563
                  เช็คเรียกเก็บแล้ว</label>
                <br />
                <label id="PaymentStatus2_4" style="font-size: 1.1rem;">วันที่โอน 17/07/2563</label>
                <br />
              </div>

              <div  id ="PaymentStatus5">
                <label id="PaymentStatus1_5" style="font-size: 1.1rem;">จ่ายคืนผู้ฝาก ธนาคาร A เลขที่เช็ค 1111111111
                  วันที่ออก 17/07/2563
                  เช็คเรียกเก็บแล้ว</label>
                <br />
                <label id="PaymentStatus2_5" style="font-size: 1.1rem;">วันที่โอน 17/07/2563</label>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row centered-content mt-2">
          <div class="col-11">
            <fieldset>
              <legend translate>Latest status</legend>
              <label id="Status1" style="font-size: 1.1rem;" translate>จ่ายคืนผู้ฝาก</label>
              <br />
              <label id="Status2" style="font-size: 1.1rem;">วันที่ 17/07/2563</label>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="row centered-content mt-2 mb-3">
        <div class="col-11 centered-content">
          <button class="btn btn-default m-2 sr-only" style="width: 180px;" (click)="Back()" translate>
            <i class="fas fa-chevron-left bank-card-arrow"></i>
            Back
          </button>
          <button class="btn btn-default m-2" style="width: 180px;" (click)="BackToHome()" translate>
            Home
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- End Refund Details -->

  <div class="container centered-content">
    <div class="modal" id="dlgFile" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content" style="width: 100vw; height: 100vh; position: fixed; top: 0px; left: 0px;
                overflow-y: auto;">
          <div class="modal-header">
            <h4 class="modal-title" id="FileNameTitle" style="padding-left: 10px;">File</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">X</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div class="row">
              <div class="col-12 centered-content">
                <iframe width="95%" style="height: 90vh;" id="ViewDocFrame" class="centered-content"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/refund-deposits/refund-deposits.component.html